module.exports = __webpack_public_path__ + "img/portrait-female-work-having-video-call@2x.e8876a06.png";